import { render, staticRenderFns } from "./CaptionBottom.vue?vue&type=template&id=1b652be2"
import script from "./CaptionBottom.vue?vue&type=script&lang=js"
export * from "./CaptionBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports